import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ProjectDescription from "./Pages/ProjectDescription";
import "./App.css";
import AboutUs from "./Pages/AboutUs";
import ContactUs from "./Pages/ContactUs";
import FAQ from "./Pages/FAQ";
import Home from "./Pages/Home";
import HowWeWork from "./Pages/HowWeWork";
import Projects from "./Pages/Projects";
import Services from "./Pages/Services";
import PublicLayout from "./PublicLayout/PublicLayout";
import Blog from "./Pages/Blog";
import BlogPage from "./Pages/BlogPage";
import ContactUsv2 from "./Pages/ContactUsv2";

function App() {
  return (
    <div>
      <Routes>
        {/* <Route><Navbar /></Route> */}
        <Route element={<PublicLayout />}>
          <Route
            path="/view-details/:projectName"
            element={<ProjectDescription />}
          />
          <Route exact path="/" element={<Home />} />
          <Route exact path="/about-us" element={<AboutUs />} />
          <Route exact path="/our-services" element={<Services />} />
          <Route exact path="/how-we-work" element={<HowWeWork />} />
          <Route exact path="/our-projects" element={<Projects />} />
          <Route exact path="/contact-us" element={<ContactUs />} />
          <Route exact path="/contact-us-v2" element={<ContactUsv2 />} />
          <Route exact path="/frequently-asked-questions" element={<FAQ />} />      
          <Route exact path="/blog" element={<Blog />} />
        </Route>
      </Routes>
    </div>
  );
}




export default App;
